import React from "react";

const STEPS = [
  { n: "01", label: "Awareness", note: "Seeing clearly, without denial." },
  { n: "02", label: "Better Thinking", note: "Questioning the story you tell yourself." },
  { n: "03", label: "Better Decisions", note: "Choosing on purpose, not by default." },
  { n: "04", label: "Intentional Action", note: "Doing what the wiser version of you would do." },
  { n: "05", label: "Consistent Behavior", note: "Repetition that becomes identity." },
  { n: "06", label: "Growth", note: "The result, not the starting point." },
];

export default function PhilosophyFlow() {
  return (
    <div data-testid="philosophy-flow" className="grid grid-cols-1 md:grid-cols-6 md:divide-x divide-[#D8CBAE] border-t border-b border-[#D8CBAE]">
      {STEPS.map((s, i) => (
        <div
          key={s.label}
          className={`group relative flex md:flex-col gap-4 md:gap-0 py-6 md:py-9 md:px-5 border-b md:border-b-0 border-[#E7E3DA] ${i === STEPS.length - 1 ? "md:bg-[#0F2C59] md:text-white" : ""}`}
        >
          <span className={`im-numeral text-3xl md:text-4xl ${i === STEPS.length - 1 ? "md:text-[#C9A25A] text-[#B58A3E]" : "text-[#B58A3E]"}`}>{s.n}</span>
          <div className="md:mt-5">
            <div className={`font-serif-display text-lg md:text-xl font-semibold leading-tight ${i === STEPS.length - 1 ? "md:text-white text-[#17181C]" : "text-[#17181C]"}`}>{s.label}</div>
            <p className={`text-xs mt-2 leading-relaxed ${i === STEPS.length - 1 ? "md:text-slate-300 text-[#8A8F99]" : "text-[#8A8F99]"}`}>{s.note}</p>
          </div>
          {i < STEPS.length - 1 && (
            <span className="hidden md:block absolute -right-[7px] top-9 text-[#B58A3E] text-sm z-10" aria-hidden="true">→</span>
          )}
        </div>
      ))}
    </div>
  );
}
